import styled from '../../../theme/styled'
import { styledComponentWithProps } from '../../Styled/Shared'

const BlackCross = require('./ic_clear_black_24px.svg')
const Cross = require('./ic_clear_white_24px.svg')

export default styledComponentWithProps<{ white?: boolean }>(styled.button)`
  background: url(${({ white }) => (white ? Cross : BlackCross)});
  background-position: right center;
  background-repeat: no-repeat;

  margin-top: -5px;
  margin-right: -5px;
  height: 32px;
  width: 32px;
  border: none;

  outline: none;
  cursor: pointer;

  text-indent: -9999px;
  white-space: nowrap;
`



// WEBPACK FOOTER //
// ./src/Components/Shared/CloseButton/index.tsx